import React, { Component } from 'react'
//import AuthHeader from "../handf/AuthHeader";
import './showfile.css'
import AuthHeader from '../handf/AuthHeader'

class Agreement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      winHeight: '',
      AgreementFileId: '',
    }
  }
  componentDidMount = function () {
    let search = this.props.location.search
    let msg = new URLSearchParams(search.slice(1))
    let id = msg.get('id')
    this.setState({
      AgreementFileId: id,
    })

    const contentHeight = document.body.scrollHeight //网页正文全文高度
    const winHeight = window.innerHeight //可视窗口高度，不包括浏览器顶部工具栏
    const ua = navigator.userAgent.toLowerCase() //媒体查询当前设备
    const windows = ua.indexOf('windows')
    const macintosh = ua.indexOf('macintosh')
    const linux = ua.indexOf('linux')
    if (contentHeight < winHeight && windows === -1 && macintosh === -1) {
      this.setState({
        winHeight: winHeight - 162,
      })
    } else if (windows === -1 && macintosh === -1 && linux === -1) {
      this.setState({
        winHeight: '',
      })
    } else {
      this.setState({
        winHeight: '',
      })
    }
  }

  render() {
    return (
      <div className={'MainBox'} style={{ height: this.state.winHeight }}>
        <AuthHeader />
        {this.state.AgreementFileId === 'n50c4dpu8ca8n9sc' && (
          <div
            className={'AgreementBox'}
            style={{ height: this.state.winHeight }}
          >
            <div className={'AgreementTitle'}>
              模拟飞行服务平台注册与服务协议
            </div>
            <div className={'AgreementTit'}>一、协议确认与注册</div>
            <div className={'AgreementCon'}>
              模拟飞行服务平台是中国航空运动协会授权的为模拟飞行运动参与者提供服务的网络平台，本协议由用户与模拟飞行服务平台（以下简称
              “本平台”）共同订立。用户在注册页面勾选 “同意”
              并完成注册，即表示已充分阅读、理解并自愿接受本协议全部内容。
            </div>
            <div className={'AgreementCon'}>
              根据《中华人民共和国网络安全法》《互联网用户账号信息管理规定》等法律法规要求，本平台实行实名制注册，用户必须提供真实身份信息完成核验后方可使用服务。
            </div>
            <div className={'AgreementCon'}>
              本平台有权根据法律法规及业务需要修订本协议，修订内容在平台公示后生效。用户继续使用服务即视为同意更新后的协议。
            </div>
            <div className={'AgreementTit'}>二、实名信息与账号管理</div>
            <div className={'AgreementCon'}>
              用户注册时必须提供本人真实姓名、身份证件号码、手机号码等法定实名信息，确保信息真实、准确、完整、有效，并配合完成身份核验。
            </div>
            <div className={'AgreementCon'}>
              用户应妥善保管账号、密码及短信验证码，不得转借、出租、出售、共享账号，不得冒用他人身份信息注册。因用户保管不当或违规使用造成的账号被盗、信息泄露及相关损失，由用户自行承担。
            </div>
            <div className={'AgreementCon'}>
              用户实名信息发生变更时，应及时在平台内更新并重新完成实名核验。信息虚假、失效或拒不更新的，本平台有权限制功能、暂停服务或注销账号。
            </div>
            <div className={'AgreementTit'}>三、个人信息与隐私保护</div>
            <div className={'AgreementCon'}>
              本平台严格保护用户姓名、身份证件号码、手机号码、设备信息、IP
              地址、聊天记录等个人隐私信息，采取技术与管理措施防止信息泄露、毁损、丢失。
            </div>
            <div className={'AgreementCon'}>
              除下列情形外，本平台不向任何第三方披露用户个人信息：
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (1) 依据法律法规、监管要求及相关要求；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (2) 用户本人同意、授权或主动公开；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (3) 为完成实名核验、保障服务安全所必须；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (4)
              因黑客攻击、病毒入侵、不可抗力等非本平台可控原因导致的信息泄露。
            </div>
            <div className={'AgreementCon'}>
              本平台仅在以下合法范围内使用用户信息：
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (1) 完成实名注册、身份核验与账号管理；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (2) 发送服务通知、安全提示、协议变更等重要信息；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (3) 防范违法违规行为，维护平台安全与运营秩序；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (4) 优化服务功能与用户体验。
            </div>
            <div className={'AgreementCon'}>
              用户同意，本平台可无偿使用赛事、活动中拍摄的包含用户肖像、姓名、声音的图片、视频等素材，用于模拟飞行项目及相关赛事宣传推广。
            </div>
            <div className={'AgreementTit'}>四、用户行为规范</div>
            <div className={'AgreementCon'}>
              用户在使用服务过程中，不得实施下列行为：
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (1)
              发布、传播危害国家安全、破坏国家统一、损害国家荣誉、煽动民族仇恨、宣扬邪教、封建迷信、谣言、淫秽色情、暴力恐怖、侵权、诈骗、骚扰、垃圾广告等违法违规及违背公序良俗的信息；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (2) 假冒他人、机构或伪造身份信息，误导其他用户；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (3) 侵害他人知识产权、名誉权、隐私权等合法权益；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (4)
              传播计算机病毒、恶意程序，干扰、破坏平台服务、服务器及网络系统；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (5) 实施骚扰、人肉搜索、恐吓等侵害他人合法权益的行为；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (6) 非法获取、截获、篡改、删除他人信息或数据；
            </div>
            <div className={'AgreementCon'} style={{ textIndent: '4em' }}>
              (7) 其他违反国家法律法规及本协议约定的行为。
            </div>
            <div className={'AgreementCon'}>
              对违反上述规定的用户，本平台有权采取删除内容、限制功能、暂停使用、封禁账号、终止服务等措施，并保留追究法律责任的权利。
            </div>
            <div className={'AgreementTit'}>五、合法使用与法律责任</div>
            <div className={'AgreementCon'}>
              用户使用本平台服务应严格遵守中华人民共和国法律、行政法规及相关监管规定，对账号下所有操作行为承担全部法律责任。
            </div>
            <div className={'AgreementCon'}>
              用户行为涉嫌违法违规的，应自行承担民事、行政乃至刑事责任；本平台可随时单方终止服务，无需提前通知，并配合监管及司法机关开展调查处理。
            </div>
            <div className={'AgreementTit'}>六、免责声明</div>
            <div className={'AgreementCon'}>
              互联网具有开放性，用户自行上传至平台的资料存在被复制、转载、篡改等风险，相关责任与后果由用户自行承担。
            </div>
            <div className={'AgreementCon'}>
              本平台不保证服务绝对不间断、无差错、完全安全，不对服务的及时性、准确性、安全性、完整性作出承诺。
            </div>
            <div className={'AgreementCon'}>
              因不可抗力、政策调整、网络故障、第三方服务问题、网络攻击等本平台不可控原因导致服务中断或异常的，本平台不承担责任。
            </div>
            <div className={'AgreementCon'}>
              本平台依据本协议及平台规则对信息、内容进行管理，不对正常的内容删除、存储失败承担责任。
            </div>
            <div className={'AgreementTit'}>七、附则</div>
            <div className={'AgreementCon'}>
              本协议的订立、履行、解释及争议解决均适用中华人民共和国法律。
            </div>
            <div className={'AgreementCon'}>
              因本协议产生的争议，双方应优先友好协商解决；协商不成的，任何一方均有权向本平台所在地人民法院提起诉讼。
            </div>
            <div className={'AgreementCon'}>
              本平台未行使本协议项下任何权利，不视为对该权利的放弃。
            </div>
            <div className={'AgreementCon'}>
              本协议部分条款被认定无效的，不影响其他条款的效力。
            </div>
            <div className={'AgreementCon'}>
              本协议最终解释权归模拟飞行服务平台所有。
            </div>
          </div>
        )}
        {/* {this.state.AgreementFileId === 'f8t8f3muh8w2r7g8' && (
          <div style={{ fontSize: 20 }}>《用户注册和隐私保护服务协议》</div>
        )} */}
      </div>
    )
  }
}

export default Agreement
